import { render, staticRenderFns } from "./broadside.vue?vue&type=template&id=83a365ca&scoped=true&"
import script from "./broadside.vue?vue&type=script&lang=js&"
export * from "./broadside.vue?vue&type=script&lang=js&"
import style0 from "./broadside.vue?vue&type=style&index=0&id=83a365ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a365ca",
  null
  
)

export default component.exports